import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { environment } from '../../../../environments/environment';
import { ConfirmationDialogData } from '../../models/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent {
  confirmationData: ConfirmationDialogData;
  rejectForm: FormGroup;
  showConfirmButton: boolean = true;
  showTextbox: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) private dialogData: ConfirmationDialogData,
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private formBuilder: FormBuilder,
  ) {
    this.confirmationData = { ...this.dialogData };
    this.showTextbox = !!this.confirmationData.showTextbox;
    if (this.confirmationData.showConfirm && this.confirmationData.showConfirm === 'false') {
      this.showConfirmButton = false;
    }
    this.rejectForm = this.createFormGroup();
  }

  private createFormGroup(): FormGroup {
    return this.formBuilder.group({
      reason: [null, [Validators.required, Validators.maxLength(environment.maxCharLimit)]],
    });
  }
}
